import { gql } from "apollo-boost"

export const GET_PROJECT_BENEFICIARIES_COUNT_BY_PREVENTION_LEVEL = gql`
  query ProjectBeneficiariesCountByPreventionLevelAndAgeRange ($submissionId: ID!){
    ProjectBeneficiariesCountByPreventionLevelAndAgeRange(submissionId: $submissionId) {
      PRIMARY {
        zeroToFive {
          male_count
          female_count
          total_count
          no_gender_count
        }
        sixToEleven {
          male_count
          female_count
          total_count
          no_gender_count
        }
        twelveToSeventeen {
          male_count
          female_count
          total_count
          no_gender_count
        }
        eightTeenToTwentyNine {
          male_count
          female_count
          total_count
          no_gender_count
        }
        thirtyToFiftyNine {
          male_count
          female_count
          total_count
          no_gender_count
        }
        moreThanSixty {
          male_count
          female_count
          total_count
          no_gender_count
        }
      }
      TERTIARY {
        zeroToFive {
          male_count
          female_count
          total_count
          no_gender_count
        }
        sixToEleven {
          male_count
          female_count
          total_count
          no_gender_count
        }
        twelveToSeventeen {
          male_count
          female_count
          total_count
          no_gender_count
        }
        eightTeenToTwentyNine {
          male_count
          female_count
          total_count
          no_gender_count
        }
        thirtyToFiftyNine {
          male_count
          female_count
          total_count
          no_gender_count
        }
        moreThanSixty {
          male_count
          female_count
          total_count
          no_gender_count
        }
      }
      SECONDARY {
        zeroToFive {
          male_count
          female_count
          total_count
          no_gender_count
        }
        sixToEleven {
          male_count
          female_count
          total_count
          no_gender_count
        }
        twelveToSeventeen {
          male_count
          female_count
          total_count
          no_gender_count
        }
        eightTeenToTwentyNine {
          male_count
          female_count
          total_count
          no_gender_count
        }
        thirtyToFiftyNine {
          male_count
          female_count
          total_count
          no_gender_count
        }
        moreThanSixty {
          male_count
          female_count
          total_count
          no_gender_count
        }
      }
      no_record {
        zeroToFive {
          male_count
          female_count
          total_count
          no_gender_count
        }
        sixToEleven {
          male_count
          female_count
          total_count
          no_gender_count
        }
        twelveToSeventeen {
          male_count
          female_count
          total_count
          no_gender_count
        }
        eightTeenToTwentyNine {
          male_count
          female_count
          total_count
          no_gender_count
        }
        thirtyToFiftyNine {
          male_count
          female_count
          total_count
          no_gender_count
        }
        moreThanSixty {
          male_count
          female_count
          total_count
          no_gender_count
        }
      }
    }
  }
`
